import { useAppSelector } from '@/store/hooks';
import {
  selectCampaignTemplateCategories,
  selectCampaignTemplateSuites,
} from '@/store/slices/campaign-templates/selectors';
import { CampaignTemplate } from '@/connection/campaigns/fetch-campaign-templates';

export interface SuiteData {
  category: string;
  templates: CampaignTemplate[];
  templateCount: number;
}

export const useTemplateCategories = () => {
  const categories = useAppSelector(selectCampaignTemplateCategories);
  const suites = useAppSelector(selectCampaignTemplateSuites);

  const getCategoryTemplateCount = (category: string) => {
    return suites.find((s) => s.category === category)?.templateCount ?? 0;
  };

  return { categories, suites, getCategoryTemplateCount };
};
